export default "<p>right-panel works!</p>\n"